module.exports = __webpack_public_path__ + "img/low-activity.4fcacc6f.webp";